import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

export default class ConfirmAccountNoticeRoute extends Route {
  @service auth!: AuthService;

  redirect() {
    if (!this.auth.user?.defaultEnvironment) {
      return this.router.transitionTo('no_accessible_workspaces');
    }

    // Earlier, we used to have a dedicated confirm your account page. Now we
    // have changed that to be a persistent alert at the top of the app, so we
    // want to ensure that we redirect to the dashboard.
    return this.router.transitionTo('dashboard', this.auth.user?.defaultEnvironment.id);
  }
}
